<template>
  <a-form :form="form">
    <a-row :gutter="16">
        <a-form-item label="Date Create">
          <a-date-picker
          placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="['tgl_buat', {rules: [{required: true}],
            initialValue: moment(initialData.informasi.tgl_buat, getDefaultDateFormat)}]"
          />
        </a-form-item>
        <a-form-item label="No SPPD">
            <a-select
                    :disabled="this.mode==='Edit'"
                    showSearch
                    placeholder="Select SPPD Number"
                    @change="handleListSPPD"
                    v-decorator="['id_sppd', {rules: [{required: true}], initialValue: initialData.informasi.no_sppd}]"
            >
                <a-select-option v-for="item in listNoSPPD" :key="item.no_sppd">{{item.no_sppd}}
                </a-select-option>
            </a-select>
        </a-form-item>
        <!-- <a-form-item label="Assignee">
          <a-list
                  itemLayout="vertical"
                  :dataSource="listAssignee"
                  :pagination="pagination"
                   size="small" bordered
          >
              <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                      <div slot="description" class="margin-remove">
                          <span>{{item.index}}. {{item.user_assignee}}</span>
                      </div>
                  </a-list-item-meta>
              </a-list-item>
          </a-list>
        </a-form-item> -->
        <a-form-item label="Assignee">
          <a-select :disabled="true"
            mode="multiple"
            v-decorator="['assignee', {rules: [{required: true}],initialValue: tlcAssignee}]"
          >
            <!-- <a-select-option v-for="(data) in listAssignee" :key="data.user_assignee">{{data.user_assignee}}</a-select-option> -->
          </a-select>
        </a-form-item>
        <a-form-item label="Location">
          <a-textarea
            v-decorator="['lokasi', {rules: [{required: false}], initialValue: initialData.informasi.lokasi}]"
            :disabled="true"
          ></a-textarea>
        </a-form-item>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
export default {
  name: "InformasiLapPD",
  props: {
    mode: String,
    collectData: {},
    isDraft: Boolean,
  },
  data() {
    return {
      listNoSPPD: [],
      listAssignee: {},
      tlcAssignee: null,
      id_sppd: "",
      pagination: {
          onChange: page => {
              console.log(page);
          },
          pageSize: 5,
          size: "small"
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getDefaultDateFormat","getStandartFormatDate","getAuth"
    ]),
    initialData() {
      let informasi = {};
      if (this.collectData.informasi === undefined || this.collectData.length <= 0) {
        if (this.mode === "Create" && !this.isDraft) {
          this.fetchListNoSPPD();
        } else {
          this.listNoSPPD = this.collectData.listpdEditMode;
        }
        informasi = {
          tgl_buat: moment().utc(true),
          id_sppd: "",
          no_sppd: "",
          lokasi: "",
        };
        return { informasi };
      } else {
        
        if (this.mode === "Create" && !this.isDraft) {
          this.fetchListNoSPPD();
        } else {
          this.listNoSPPD = this.collectData.listpdEditMode;
        }
        if (this.collectData.informasi != undefined) {
          let inform = this.collectData.informasi;
          this.id_sppd = inform.id_sppd;
          this.fetchListAssignee();


          informasi = {
            tgl_buat: moment(this.collectData.informasi.tgl_buat).format(
              this.getDefaultDateFormat
            ),
            id_sppd: this.collectData.informasi.id_sppd,
            no_sppd: (this.mode == "Edit" || this.isDraft) ? this.listNoSPPD[0].no_sppd : this.collectData.informasi.no_sppd,
            lokasi: this.collectData.informasi.lokasi
          };
          return { informasi };
        }else{
          return { informasi:{} };
        }
      }
    },
  },
  created() {
    this.$store.dispatch("FETCH_ACTIVE_PROJECT");
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    if (this.mode === "Create") {
        this.listNoSPPD = [];
    } else {
        this.pageLoading = false;
    }
  },
  methods: {
    moment,
    handleListSPPD(e) {
      let data = {};
      data = this.listNoSPPD.filter(
          obj => obj.no_sppd.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      
      /* console.log("data[0].id_sppd");
      console.log(data[0]); */

      this.id_sppd = data[0].id_sppd;
      if(this.collectData.informasi!=undefined){
        this.collectData.informasi.id_sppd = data[0].id_sppd;
      }
      
      if (data[0].kota!=undefined || data[0].kota!=null){
        this.initialData.informasi.lokasi =  data[0].kota+" - "+data[0].alamat ;
      }else{
        this.initialData.informasi.lokasi =  data[0].alamat;
      }
      this.fetchListAssignee();
      
    },
    fetchListNoSPPD() {
      axios({
          method: "get",
          url: this.$serviceUrl + "Lap_kegiatan_pd/list_sppd",
          params: {
              tlc: this.getAuth.username
          },
          auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
          },
          headers: {
              "X-API-KEY": this.getAuth.apikey
          }
      })
          .then(response => {
            this.listNoSPPD = response.data.list_sppd;
            this.pageLoading = false;
            if (this.mode === "Create" && this.listNoSPPD.length === 0) {
              this.displayMessageValue("error-nothave-sppd",'tidak memiliki no sppd');
              this.$router.go(-1);
            }
          })
          .catch(err => {
              if (err.response.status === 404) {
                  if (this.mode === "Create") {
                      this.displayMessage("404");
                      this.$router.go(-1);
                  } else {
                      this.pageLoading = false;
                      this.loading = false;
                  }
              }
          });
    },
    fetchListAssignee() {
      axios({
          method: "get",
          url: this.$serviceUrl + "Lap_kegiatan_pd/user_assignee",
          params: {
              tlc: this.getAuth.username,
              id_sppd: this.id_sppd,
          },
          auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
          },
          headers: {
              "X-API-KEY": this.getAuth.apikey
          }
      })
          .then(response => {
              this.listAssignee = response.data.user_assignee;
              this.pageLoading = false;

              if (this.listAssignee!=undefined || this.listAssignee.length>0){
                this.tlcAssignee = Object.keys(this.listAssignee).map(i => this.listAssignee[i].user_assignee);
                 
              }
          })
          .catch(err => {
              if (err.response.status === 404) {
                  if (this.mode === "Create") {
                      this.displayMessage("404");
                      this.$router.go(-1);
                  } else {
                      this.pageLoading = false;
                      this.loading = false;
                  }
              }
          });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.form.resetFields()
          this.displayMessage("form-warning");
          return;
        }

        if (this.listAssignee.length == 0) {
          this.displayMessageValue("error-other", "Assignee can't be empty!");
          return;
        }

        let dataValues = {};
        if (this.mode==='Create' || this.isDraft){
          let id_sppdVal = this.listNoSPPD.filter(
            obj => obj.no_sppd.toLowerCase().indexOf(values.id_sppd.toLowerCase()) >= 0
          );

          dataValues = {
            ...values,
            tgl_buat: values.tgl_buat.format(this.getStandartFormatDate),
            id_sppd: id_sppdVal[0].id_sppd,
            no_sppd: id_sppdVal[0].no_sppd,
            Assignee: this.listAssignee,
            lokasi: values.lokasi
          };
        } else {
          dataValues = {
            ...values,
            tgl_buat: values.tgl_buat.format(this.getStandartFormatDate),
            id_sppd: this.collectData.informasi.id_sppd,
            no_sppd: this.collectData.informasi.no_sppd,
            Assignee: this.listAssignee,
            lokasi: this.collectData.informasi.lokasi
          };
        }

          Event.$emit("informasi", {
            informasi: dataValues,
          });
      });
    }
  }
};
</script>

<style>
</style>